import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/services/env.service';
@Injectable()
export class LogService {
  readonly baseUrl = `${this.env.URL_API_V1}/logs`;
  constructor(private readonly http: HttpClient, private env: EnvService) {}

  updateLogout(id, inactivity, userID) {
    return this.http.get<any>(`${this.baseUrl}/updateLogout/${id}`, {
      params: { inactivity, userID },
    });
  }
  getAllLogs() {
    return this.http.get<any>(`${this.baseUrl}/getAllLogs`);
  }
}
